module.exports = __webpack_public_path__ + "img/mobile.1612057c.png";